<div class="c-modal c-modal--sm" id="modal-{{vm.uid}}">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
					<p style="font-size: 22px">
						{{ 'Employees.Placeholder.UpdateInsuranceTitle' | translate }} 
					</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close"
							(click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content u-no-pt">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<form name="vm.form" #mainForm="ngForm" class="c-form u-ost-md">
					<div class="o-grid o-grid--wrap">
						<div class="o-grid__cell o-grid__cell--w-100 u-no-p u-osb-sm">
							{{ 'Employees.Name' | translate }}: {{vm.getName()}}
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
							<div style="padding-bottom: 20px;" *ngIf="vm.businessUserWorker.insuranceWallets && vm.businessUserWorker.insuranceWallets?.length > 0">
								<item-notification icon="attention" [text]="vm.getExistingInsurancePolicies()" [theme]="5"></item-notification>
							</div>
							<div class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': vm.submitted && !vm.selectedPolicy }">
	                            <label for="policy" class="c-form__label c-form__label">
	                                {{ 'Employees.Placeholder.PolicyNumber' | translate }} *
	                            </label>
	                            <mat-select id="policy"
                                    name="policy"
                                    *ngIf="vm.activePolicies"
                                    class="mat-select mat-select--border"
                                    [(value)]="vm.selectedPolicy"
                                    required >
	                                <mat-option *ngFor="let policy of vm.activePolicies ; let $index=index"
	                                           [value]="policy">
	                                    {{ policy.policyNumber }} {{ policy.displayName }}
	                                </mat-option>
	                            </mat-select>
	                        </div>
							<div class="c-form__group u-osb-lg" *ngIf="!vm.isInsuranceDatePickerHidden" [ngClass]="{ 'c-form__group--error': vm.submitted && !vm.extraData?.activationDate }">
								<label for="activationDate" class="c-form__label c-form__label">
								    {{ 'Employees.Placeholder.ActivationDate' | translate }} *
								</label>
								<div id="datePickerContainer" *ngIf="vm.initialized">
								    <input-datepicker-new id="{{ 'activation-' + vm.uid }}"
					                    name="activationDate"
					                    [(model)]="vm.extraData.activationDate"
					                    [minDate]="vm.minDate"
					                    data-el-parent="datePickerContainer" 
					                    [hasTimepicker]="false"
					                    [hasCalendarIcon]="true"
					                    [isSingleDate]="true"
					                    [isFixedPosition]="true" 
					                    [isRequired]="true"></input-datepicker-new>
								</div>
							</div>
							<div style="display:none;" class="c-form__group u-osb-lg">
								<label class="c-form__label c-form__label">
								    {{ 'Employees.Placeholder.TerminationDate' | translate }}
								</label>
								<div id="datePickerContainer" *ngIf="vm.initialized">
								    <input-datepicker-new id="{{ 'terminate-' + vm.uid }}"
										name="terminationDate"
										[(model)]="vm.extraData.terminationDate"
										[minDate]="vm.minDate"
										data-el-parent="datePickerContainer" 
										[hasTimepicker]="false"
										[hasCalendarIcon]="true"
										[isSingleDate]="true"
										[isFixedPosition]="true"></input-datepicker-new>
								</div>
							</div>
						</div>
					</div>
					<div class="c-panel u-no-p u-ost-sm u-osb-sm">
						<button type="button"
							id="updateWorkerInsuraceButton"
							(click)="vm.submit(mainForm)"
							[disabled]="vm.processing || !vm.initialized"
							class="c-button c-button--s2 c-button--narrow c-button--fit u-no-wrap">
							{{ 'Modal.Button.Update' | translate }}
						</button>
					</div>
				</form>
				<loader-overlay *ngIf="vm.processing || !vm.initialized"></loader-overlay>
			</div>
		</div>
	</div>
</div>
